export class FieldOption {
    constructor(
        public text: string,
        public value: string,
        public selectable: boolean,
        public children: Array<FieldOption>
    ) {}
}
